import script from "./ThreeDViewerPartSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThreeDViewerPartSearch.vue?vue&type=script&setup=true&lang=ts"

import "./ThreeDViewerPartSearch.vue?vue&type=style&index=0&id=0fcfcad4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fcfcad4"]])

export default __exports__